import { useState } from "react";
import SellerStep from "../../components/seller/SellerStep";
import { SharedFormField } from "../../components/shared";
import ChoiceGroup from "../../components/forms/ChoiceGroup";
import CheckboxGroup from "../../components/forms/CheckboxGroup";
import { useSellerState } from "../../js/state/sellerState";

export default function SellerExteriorFeatures() {
  const saved = useSellerState().seller.portfolio.exteriorFeatures || {};
  const [form, setForm] = useState({
    siding: saved.siding || [],
    roof: saved.roof || "",
    outdoor: saved.outdoor || [],
    landscaping: saved.landscaping || "",
    fencing: saved.fencing || "",
    pool: saved.pool || "",
    notes: saved.notes || "",
  });

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  return (
    <SellerStep
      title="Exterior features"
      lead="Curb appeal, building envelope, and outdoor living as a buyer would see them from the street and backyard."
      sectionKey="exteriorFeatures"
      value={form}
    >
      <section className="checklist-section">
        <h2>Envelope</h2>
        <CheckboxGroup
          label="Siding / finish"
          name="siding"
          values={form.siding}
          onChange={update}
          layout="grid"
          options={[
            { value: "brick", label: "Brick" },
            { value: "stone", label: "Stone" },
            { value: "fiber-cement", label: "Fiber cement" },
            { value: "vinyl", label: "Vinyl" },
            { value: "wood", label: "Wood" },
            { value: "stucco", label: "Stucco" },
          ]}
        />
        <SharedFormField
          label="Roof type"
          name="roof"
          type="select"
          value={form.roof}
          onChange={update}
          options={[
            { value: "asphalt", label: "Asphalt shingle" },
            { value: "metal", label: "Metal" },
            { value: "tile", label: "Tile" },
            { value: "slate", label: "Slate" },
            { value: "other", label: "Other" },
          ]}
        />
      </section>

      <section className="checklist-section">
        <h2>Outdoor Living</h2>
        <CheckboxGroup
          label="Outdoor spaces"
          name="outdoor"
          values={form.outdoor}
          onChange={update}
          layout="grid"
          options={[
            { value: "porch", label: "Porch" },
            { value: "deck", label: "Deck" },
            { value: "patio", label: "Patio" },
            { value: "covered", label: "Covered outdoor" },
            { value: "outdoor-kitchen", label: "Outdoor kitchen" },
            { value: "shed", label: "Shed / workshop" },
          ]}
        />
        <ChoiceGroup
          label="Landscaping"
          name="landscaping"
          value={form.landscaping}
          onChange={update}
          options={[
            { value: "low-maintenance", label: "Low maintenance" },
            { value: "established", label: "Established / mature" },
            { value: "needs-work", label: "Needs work" },
          ]}
        />
        <ChoiceGroup
          label="Fencing"
          name="fencing"
          value={form.fencing}
          onChange={update}
          options={[
            { value: "full", label: "Fully fenced" },
            { value: "partial", label: "Partial" },
            { value: "none", label: "None" },
          ]}
        />
        <ChoiceGroup
          label="Pool / spa"
          name="pool"
          value={form.pool}
          onChange={update}
          options={[
            { value: "pool", label: "Pool" },
            { value: "spa", label: "Spa" },
            { value: "both", label: "Pool and spa" },
            { value: "none", label: "None" },
          ]}
        />
        <SharedFormField
          label="Exterior notes for my agent"
          name="notes"
          type="textarea"
          value={form.notes}
          onChange={update}
          placeholder="Drainage, views, alley access, irrigation, HOA exterior rules."
        />
      </section>
    </SellerStep>
  );
}
